import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { Col, Row } from 'reactstrap';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { getNextStep, getVisibleWizardFieldOrder, WIZARD, WIZARD_NUM } from '../helper';

const AboutBusiness = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    isForEDD,
    applicationForm,
    handleChange,
    handlePrev,
    editMode,
    setData,
    formType
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                if (fieldError) {
                    showError(fieldError);
                    return false;
                }
            }
        }
        
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStep(wizard, applicationForm, data, editMode) });
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            updatedErrors[field] = errorMsg;
            return updatedErrors;
        });
    };

    return (
        <div className="row">
            <div className="col-12">
                <h2 style={{ fontWeight: 'bolder' }} className='pt-3 mb-4'>About your business</h2>
                
                <div className='mb-3'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["primaryBusiness"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('primaryBusiness', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["productsOrServices"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        className="my-3"
                        onError={(errorMsg) => handleErrors('productsOrServices', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["businessPurpose"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        className="my-3"
                        onError={(errorMsg) => handleErrors('businessPurpose', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["primaryCustomer"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        className="my-3"
                        onError={(errorMsg) => handleErrors('primaryCustomer', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["revenueRange"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        className="my-3"
                        onError={(errorMsg) => handleErrors('revenueRange', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <Row>
                        <Col className='col-md-6 col-12'>
                            <WrapperField
                                disabled={asLabel}
                                jsonField={cyclosFields["hasAuditStatements"]}
                                dataObj={data}
                                onChange={handleUpdateFormData}
                                showError={hasError}
                                className="my-3"
                                onError={(errorMsg) => handleErrors('hasAuditStatements', errorMsg)}
                                isForEDD={isForEDD}
                            />
                        </Col>

                        <Col className='col-md-6 col-12'>
                            <WrapperField
                                disabled={asLabel}
                                jsonField={cyclosFields["hasAnnualStatements"]}
                                dataObj={data}
                                onChange={handleUpdateFormData}
                                showError={hasError}
                                className="my-3"
                                onError={(errorMsg) => handleErrors('hasAnnualStatements', errorMsg)}
                                isForEDD={isForEDD}
                            />
                        </Col>
                    </Row>

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["hasFinancialForecast"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        className="my-3"
                        onError={(errorMsg) => handleErrors('hasFinancialForecast', errorMsg)}
                        isForEDD={isForEDD}
                    />

            
                </div>

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.AboutBusiness}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.AboutBusiness}
                        hideSubmitButton={hideButtons}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(AboutBusiness);
